import MessagesContainer from './messages-container';

export default MessagesContainer;
